<template>
    <span @click="goBack">
        <img src="../assets/rollback.white.png" height="18px" alt="" style="margin-bottom: 0 "> <span style="font-size: 14px">返回</span>
    </span>
</template>

<script setup>
    // icon-fanhui
    import {isLogin} from "../utils/llm.tools";
    const href = isLogin()? '/recent': '/mobile/home';
    const goBack = () => window.location.href = href;
</script>

